module.exports = __webpack_public_path__ + "static/Sustainability_Facility_Improvements-7b170df872794006f2bff94410faf688.pdf";